import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Title = styled.h3`
  ${({ theme }) => css`
    align-items: center;
    color: ${theme.v2.colors.brand.menuPrimaryDark};
    display: flex;
    font-size: ${theme.v2.font.sizes.sm};
    font-weight: ${theme.v2.font.weights.bold};
    gap: 10px;
    margin: 0;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      align-items: flex-start;
      font-size: ${theme.v2.font.sizes.xs};
    }
  `}
`;

export const IconMaia = styled.img`
  ${({ theme }) => css`
    height: 32px;
    width: 32px;
  
    @media (max-width: ${theme.v2.breakpoints.sm}) {
      height: 20px;
      width: 20px;
    }
  `}
`;

export const InputHeadText = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowPure};
    font-size: ${theme.v2.font.sizes.xs};
    margin: 24px 0;
  `}
`;

export const ButtonWrapper = styled.div`
  margin: 32px 0;
`;
